<template>
  <div>
    <MediaObjectUploadAlt
      :mediaSource="mediaSource"
      :formats="formats"
      :maxSizeBytes="maxSizeBytes"
      :errorTooLargeMessage="$t('forms.fileTooLarge', { size: maxSizeMb } )"
      @error="setErrorMessage"
      @loading="loading = $event"
      v-model="uploadUrl"
    />
    <UploadErrorMessage :errorMessage="errorMessage" :loading="loading" />
    <div class="text-left my-3" v-if="loading">
      {{ $t("forms.uploading") }}
      <v-progress-linear
        indeterminate
        color="primaryAction darken-2"
      ></v-progress-linear>
    </div>
  </div>
</template>
<script>
import MediaObjectUploadAlt from "@/components/MediaObjectUploadAlt";
import {
  IMAGE_FORMATS,
  VIDEO_FORMATS,
  AUDIO_FORMATS,
  MAX_VIDEO_UPLOAD_MEGABYTES,
  MAX_VIDEO_UPLOAD_BYTES,
} from "@/const";
import UploadErrorMessage from "./UploadErrorMessage.vue";
const EXTENSION_NAME = "info";
export default {
  props: {
    editor: Object,
  },
  components: {
    MediaObjectUploadAlt,
    UploadErrorMessage,
  },
  data() {
    return {
      loading: false,
      uploadUrl: null,
      errorMessage: null,
    };
  },
  methods: {
    setErrorMessage(message) {
      this.errorMessage = message;
    },
  },
  watch: {
    uploadUrl(newValue) {
      this.editor.chain().focus().setMediaSrc(newValue).run();
    },
    mediaSource(newValue) {
      this.uploadUrl = newValue;
    },
  },
  computed: {
    formats() {
      return IMAGE_FORMATS + "," + VIDEO_FORMATS + ", " + AUDIO_FORMATS;
    },
    mediaSource() {
      return this.editor.getAttributes(EXTENSION_NAME).src;
    },
    maxSizeMb() {
      return MAX_VIDEO_UPLOAD_MEGABYTES
    },
    maxSizeBytes() {
      return MAX_VIDEO_UPLOAD_BYTES;
    },
  },
};
</script>